import React from "react";
import { Table, Alert, Tag } from "antd";

import { Spinner } from "../components/spinner/Spinner";
import useFetchFiles from "../app/files/mutations";
import { formatDateTime } from "../utils/utils";

import "../styles/files/files.scss";

const columns = [
  {
    title: "Nombre del archivo",
    dataIndex: "id",
    key: "id",
    render: (_, record) => (
      <a
        className="files__info_link"
        href={record.url}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        {record.id}
        {!record.url && <Tag color="error">URL no encontrada</Tag>}
      </a>
    ),
  },
  {
    title: "Detalle del error",
    dataIndex: "error",
    key: "error",
  },
  {
    title: "Fecha Procesamiento",
    dataIndex: "date",
    key: "date",
    render: (text) => formatDateTime(text),
    width: 200
  },
];

export const Files = () => {
  const { isLoading, data, isError, error } = useFetchFiles();

  if (data && data.length > 0) {
    data.sort(function (a, b) {
      var c = new Date(a.date);
      var d = new Date(b.date);
      return d - c;
    });
  }
  if (isLoading) return <Spinner tip="Cargando, por favor espere..." />;

  if (isError && error instanceof Error)
    return (
      <Alert
        message="Ocurrión un error"
        description={error.message}
        type="error"
        showIcon
      />
    );

  return (
    <>
      <div className="files">
        <div className="files__header">
          <h2>Archivos en Error</h2>
        </div>
        <div className="files__table">
          <Table
            columns={columns}
            dataSource={data}
            locale={{
              emptyText: "Sin datos",
            }}
          />
        </div>
      </div>
    </>
  );
};
